import React, { useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { EllipsisIcon, GamifyIcon } from '../../components/GamifyIcon';
import Moment from 'moment';
import AppointmentOptionsMenu from './AppointmentOptionsMenu';
import { usePermissions } from '../../context/PermissionsContext/PermissionsContext';
import { PermissionKeys } from '../../context/PermissionsContext/permissionTypes';

export default function AppointmentCard({
  user,
  appointment,
  markAppointment,
  // onRescheduleAppointment,
  //   setShowDeal,
  //   setIsBusy,
  //   setAction,
  //   markAppointment,
}) {
  const theme = useTheme();

  const { checkPermission } = usePermissions();

  const allowReassignAppointment = checkPermission(
    PermissionKeys.Scheduling_ReassignAppointment
  );

  // const [appointmentOptionsOpen, setAppointmentOptionsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  //   console.log('AppointmentCard appointment: ', appointment);

  // const handleClickOffAppointmentOptionMenu = (e) => {
  //   e.stopPropagation();
  //   setAppointmentOptionsOpen(false);
  // };

  function formatScheduleDate(date) {
    const momentDate = new Moment(`${date}`);
    // console.log('momentDate: ', momentDate);
    return momentDate.format('dddd, MMMM Do');
  }

  function formatScheduleTime(minutesPastMidnight) {
    const hours = Math.trunc(minutesPastMidnight / 60);
    const minutes = minutesPastMidnight - hours * 60;
    const momentTime = new Moment({ hour: hours, minute: minutes });
    return momentTime.format('h:mm a');
  }

  return (
    <>
      {/* NOTE: This background was only needed for custom built options menu, CustomMenu and CustomMenuItem components do not need this */}
      {/* {appointmentOptionsOpen && (
        <Box
          onClick={handleClickOffAppointmentOptionMenu}
          className="option-menu-container-background"
        ></Box>
      )} */}
      <Box
        sx={{
          cursor: 'default',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: theme.custom.background1,
          minWidth: 382,
          padding: '15px',
          border: `1px solid ${theme.custom.stroke}`,
          borderRadius: '8px',
          marginBottom: '8px',
        }}
      >
        <Box className={'appointments-list-item-left-container'}>
          {/* {console.log('AppointmentCard appointment: ', appointment)} */}
          <Box style={{ marginRight: 12 }}>
            <GamifyIcon icon={'calendar'}></GamifyIcon>
          </Box>
          <Box className={'appointments-list-item-left-text-container'}>
            <Typography
              sx={{ color: theme.custom.text, fontSize: 15, fontWeight: 600 }}
            >
              {formatScheduleDate(appointment.appointmentDate)}
            </Typography>
            <Typography
              sx={{ color: theme.custom.text, fontSize: 15, fontWeight: 600 }}
            >
              {formatScheduleTime(appointment.appointmentStartTime)} -{' '}
              {formatScheduleTime(appointment.appointmentEndTime)}
            </Typography>
            <Typography
              sx={{ color: theme.custom.text, fontSize: 12, fontWeight: 500 }}
            >
              {`[${appointment?.deal?.name}]`}
            </Typography>
            <Typography
              sx={{ color: theme.custom.text, fontSize: 12, fontWeight: 500 }}
            >
              {`Assigned to: ${appointment?.user?.name}`}
            </Typography>
            <Typography
              sx={{ color: theme.custom.text, fontSize: 12, fontWeight: 500 }}
            >
              {`Setter: ${appointment?.setter?.name}`}
            </Typography>
          </Box>
        </Box>
        <Box
          style={{
            position: 'relative',
            height: 45,
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          {/* TO DO: limit access to AppointmentOptionsMenu to admin/moderator/manager? */}
          {allowReassignAppointment && (
            <>
              <Button
                className={'appointments-option-button'}
                onClick={(e) => {
                  e.stopPropagation();
                  // setAppointmentOptionsOpen(!appointmentOptionsOpen);
                  setAnchorEl(e.currentTarget);
                }}
                disableRipple={true}
              >
                <EllipsisIcon color={'#868686'}></EllipsisIcon>
              </Button>
              <AppointmentOptionsMenu
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                appointment={appointment}
                user={user}
                markAppointment={markAppointment}
              ></AppointmentOptionsMenu>
            </>
          )}
          {/* {appointmentOptionsOpen && (
            <AppointmentOptionsMenu
              setAppointmentOptionsOpen={setAppointmentOptionsOpen}
              appointment={appointment}
              user={user}
              onTriggerAppointmentsRefetch={onTriggerAppointmentsRefetch}
              markAppointment={markAppointment}
            ></AppointmentOptionsMenu>
          )} */}
        </Box>
      </Box>
    </>
  );
}
